var map = {
	"./Admin-Panel.svg": [
		1078,
		9,
		3
	],
	"./Admin-Panel_1.svg": [
		1079,
		9,
		4
	],
	"./Android.svg": [
		1080,
		9,
		5
	],
	"./Backend.svg": [
		1081,
		9,
		6
	],
	"./ProjectLogoAnimation.svg": [
		1082,
		9,
		7
	],
	"./Web.svg": [
		1083,
		9,
		8
	],
	"./addRound.svg": [
		1084,
		9,
		9
	],
	"./announcement.svg": [
		1085,
		9,
		10
	],
	"./arc.svg": [
		1086,
		9,
		11
	],
	"./arrow.svg": [
		1087,
		9,
		12
	],
	"./back.svg": [
		1088,
		9,
		13
	],
	"./blob.svg": [
		1089,
		9,
		14
	],
	"./calculator.svg": [
		1090,
		9,
		15
	],
	"./calendar.svg": [
		1091,
		9,
		16
	],
	"./check.svg": [
		1092,
		9,
		17
	],
	"./checkBoxSquare.svg": [
		1093,
		9,
		18
	],
	"./checkbox.svg": [
		1094,
		7,
		19
	],
	"./circularTick.svg": [
		1095,
		9,
		20
	],
	"./clock.svg": [
		1096,
		9,
		21
	],
	"./closeM.svg": [
		1097,
		9,
		22
	],
	"./cross.svg": [
		1098,
		9,
		23
	],
	"./crossRed.svg": [
		1099,
		9,
		24
	],
	"./dollar.svg": [
		1100,
		9,
		25
	],
	"./download.svg": [
		1101,
		9,
		26
	],
	"./eodUpdate.svg": [
		1102,
		9,
		27
	],
	"./file.svg": [
		1103,
		9,
		28
	],
	"./filter.svg": [
		1104,
		9,
		29
	],
	"./hoverIcon.svg": [
		1105,
		9,
		30
	],
	"./iOS.svg": [
		1106,
		9,
		31
	],
	"./info.svg": [
		1107,
		9,
		32
	],
	"./leads.svg": [
		1108,
		9,
		33
	],
	"./login.svg": [
		1109,
		9,
		34
	],
	"./marketing.svg": [
		1110,
		9,
		35
	],
	"./menu.svg": [
		1111,
		9,
		36
	],
	"./module.svg": [
		1112,
		9,
		37
	],
	"./myWork.svg": [
		1113,
		9,
		38
	],
	"./newUpdate2.svg": [
		1114,
		9,
		39
	],
	"./next.svg": [
		1115,
		9,
		40
	],
	"./noOfPayment.svg": [
		1116,
		9,
		41
	],
	"./notFound.svg": [
		1117,
		9,
		42
	],
	"./platform.svg": [
		1118,
		9,
		43
	],
	"./platform_view.svg": [
		1119,
		9,
		44
	],
	"./platforms.svg": [
		1120,
		9,
		45
	],
	"./prev.svg": [
		1121,
		9,
		46
	],
	"./project.svg": [
		1122,
		9,
		47
	],
	"./projectLogo.svg": [
		1123,
		9,
		48
	],
	"./projectManager.svg": [
		1124,
		9,
		49
	],
	"./projects.svg": [
		1125,
		9,
		50
	],
	"./rectangle.svg": [
		1126,
		9,
		51
	],
	"./redCancel.svg": [
		1127,
		9,
		52
	],
	"./search.svg": [
		1128,
		9,
		53
	],
	"./share.svg": [
		1129,
		9,
		54
	],
	"./task.svg": [
		1130,
		9,
		55
	],
	"./taskIcon.svg": [
		1131,
		9,
		56
	],
	"./team.svg": [
		1132,
		9,
		57
	],
	"./team1.svg": [
		1133,
		9,
		58
	],
	"./team12.svg": [
		1134,
		9,
		59
	],
	"./teamMember.svg": [
		1135,
		9,
		60
	],
	"./tick.svg": [
		1136,
		9,
		61
	],
	"./trash.svg": [
		1137,
		9,
		62
	],
	"./user.svg": [
		1138,
		9,
		63
	],
	"./wave.svg": [
		1139,
		9,
		64
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 812;
module.exports = webpackAsyncContext;